module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDIyIDExIj48cGF0aCBkPSJNMCAxMUwxMSAwbDExIDExSDB6IiBmaWxsPSIjMzMwOTNlIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/styles/chances/triangle.svg
// module id = ./src/styles/chances/triangle.svg
// module chunks = 21